"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkout = exports.StyledLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("@ant-design/icons");
const index_1 = require("@src/app/index");
const Api = __importStar(require("@src/api"));
const renderBraintreeHostedField_1 = require("@src/components/modules/forms/renderBraintreeHostedField");
const elements_1 = require("@src/components/elements");
const actions_1 = __importDefault(require("@src/actions"));
const useBraintree_1 = require("@src/hooks/useBraintree");
const useConfig_1 = require("@src/hooks/useConfig");
const account_context_1 = require("@src/context/account-context");
const types_1 = require("@src/types");
const queries_1 = require("@src/types/queries");
const react_query_1 = require("react-query");
exports.StyledLink = (0, styled_components_1.default)(elements_1.Link) `
	font-weight: 700;
	text-decoration: underline;
	display: block;
	margin: 0.5em auto 0;
`;
const EFieldsAttributes = {
    Id: 'Id',
    Label: 'Label',
    ClassName: 'ClassName',
};
const getFieldsConfig = intl => [
    {
        [EFieldsAttributes.Id]: 'card-number',
        [EFieldsAttributes.Label]: intl.formatMessage({
            id: 'global.checkout.card_number',
            defaultMessage: 'Číslo platobnej karty',
        }),
        [EFieldsAttributes.ClassName]: 'col-12',
    },
    {
        [EFieldsAttributes.Id]: 'expiration-date',
        [EFieldsAttributes.Label]: intl.formatMessage({
            id: 'global.checkout.expiration_date',
            defaultMessage: 'Platnosť karty do',
        }),
        [EFieldsAttributes.ClassName]: 'col-6_xs-12',
    },
    {
        [EFieldsAttributes.Id]: 'cvv',
        [EFieldsAttributes.Label]: intl.formatMessage({
            id: 'global.checkout.cvv',
            defaultMessage: 'Bezpečnostný kód (CVC/CVV)',
        }),
        [EFieldsAttributes.ClassName]: 'col-6_xs-12',
    },
];
const Checkout = ({ isOrderLoading, hasRememberedCard, billingProfile, couponCode, orderParams, order, offerId, onOrderSuccess, }) => {
    var _a;
    const [isCheckoutInitialized, setIsCheckoutInitialized] = react_1.default.useState(false);
    const [error, setError] = react_1.default.useState(null);
    const [useSavedCard, setUseSavedCard] = react_1.default.useState(false);
    const [shouldSaveCard, setShouldSaveCard] = react_1.default.useState(true);
    const [isPaymentInProgress, setIsPaymentInProgress] = react_1.default.useState(false);
    const { isBraintreeLoading, initCheckout, hostedFieldsInstance, setHostedFieldsInstance, braintree3DSecureInstance, braintreeDataCollector, } = (0, useBraintree_1.useBraintree)();
    const intl = (0, react_intl_1.useIntl)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const config = (0, useConfig_1.useConfig)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const { email, telephone, firstName, lastName } = (_a = (0, account_context_1.useAccount)()) !== null && _a !== void 0 ? _a : {};
    // @ts-ignore
    const { formatted_address, city, postal_code } = (0, react_redux_1.useSelector)(state => state.admin.company);
    const formattedTelephone = telephone === null || telephone === void 0 ? void 0 : telephone.replace('+', '00');
    const hasAbroadBillingProfile = (billingProfile === null || billingProfile === void 0 ? void 0 : billingProfile.country) !== config.countryCode;
    react_1.default.useEffect(() => {
        if (hasRememberedCard) {
            setUseSavedCard(true);
        }
        setIsCheckoutInitialized(true);
    }, [hasRememberedCard]);
    react_1.default.useEffect(() => {
        if (isCheckoutInitialized) {
            initCheckout(!useSavedCard);
            if (useSavedCard) {
                setShouldSaveCard(false);
            }
            if (!useSavedCard && (order === null || order === void 0 ? void 0 : order.orderType) === types_1.ProductType.subscription) {
                setShouldSaveCard(true);
            }
        }
    }, [isCheckoutInitialized, useSavedCard, order === null || order === void 0 ? void 0 : order.orderType]);
    const sendPayment = async () => {
        try {
            if (!order) {
                throw new Error(intl.formatMessage({
                    id: 'admin.order.invalid_order',
                }));
            }
            setIsPaymentInProgress(true);
            let paymentMethodData = null;
            if (hasRememberedCard && useSavedCard) {
                paymentMethodData = await Api.Admin.getPaymentMethodNonce();
            }
            else {
                paymentMethodData = await hostedFieldsInstance.tokenize();
            }
            const amount = hasAbroadBillingProfile
                ? Number(order === null || order === void 0 ? void 0 : order.totalPriceWithoutVat.toFixed(2))
                : Number(order === null || order === void 0 ? void 0 : order.totalPrice.toFixed(2));
            const response = await braintree3DSecureInstance.verifyCard({
                // @ts-ignore
                onLookupComplete(data, next) {
                    next();
                },
                // @ts-ignore
                amount,
                nonce: paymentMethodData.nonce,
                bin: paymentMethodData.details.bin,
                email,
                mobilePhoneNumber: formattedTelephone,
                challengeRequested: true,
                billingAddress: {
                    givenName: firstName,
                    surname: lastName,
                    phoneNumber: formattedTelephone,
                    streetAddress: formatted_address,
                    locality: city,
                    postalCode: postal_code,
                },
            });
            // @ts-ignore
            if (!response.threeDSecureInfo.liabilityShifted) {
                return;
            }
            await Api.Admin.buyProductByCard({
                orderParams,
                order,
                savePaymentMethod: shouldSaveCard,
                // @ts-ignore
                nonce: response.nonce,
                billingProfile,
                deviceData: braintreeDataCollector.deviceData,
                couponCode,
                offerId,
            });
            if (order.orderType === types_1.ProductType.credit) {
                dispatch(actions_1.default.adminToggleCreditsReplenishedDialog(true));
            }
            if (onOrderSuccess) {
                onOrderSuccess(types_1.PaymentMethod.credit_card);
            }
            index_1.history.pushLocalized('/admin');
            queryClient.invalidateQueries(queries_1.Queries.getCompany);
        }
        catch (err) {
            console.error(err);
            setError(true);
        }
        finally {
            setIsPaymentInProgress(false);
        }
    };
    const fieldsConfig = getFieldsConfig(intl);
    return ((0, jsx_runtime_1.jsx)("div", { className: "Checkout m-t-m", children: (0, jsx_runtime_1.jsx)(antd_1.Row, { gutter: [16, 16], children: (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, children: (0, jsx_runtime_1.jsxs)("div", { className: "panel panel--payment", children: [(0, jsx_runtime_1.jsxs)("div", { className: "Checkout__headline", children: [(0, jsx_runtime_1.jsx)(elements_1.Icon, { className: "Checkout__icon-shield", type: "shield" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.checkout.secure_payment", defaultMessage: "Bezpe\u010Dn\u00E1 platba kartou" })] }), error && ((0, jsx_runtime_1.jsx)("div", { className: "form__errors", children: (0, jsx_runtime_1.jsx)("p", { className: "form__errors-item", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.checkout.invalid_payment_information", defaultMessage: "Neplatn\u00E9 platobn\u00E9 \u00FAdaje" }) }) })), (0, jsx_runtime_1.jsxs)("div", { children: [hasRememberedCard && ((0, jsx_runtime_1.jsx)("div", { className: "u-text-center form__row", children: (0, jsx_runtime_1.jsx)("label", { className: "form__label form__label--checkbox", children: (0, jsx_runtime_1.jsx)(elements_1.Checkbox, { checked: useSavedCard, onChange: e => {
                                                setUseSavedCard(e.target.checked);
                                                setHostedFieldsInstance(null);
                                            }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.checkout.use_saved_card", defaultMessage: "Pou\u017Ei\u0165 zapam\u00E4tan\u00FA kartu?" }) }) }) })), (!useSavedCard || !hasRememberedCard) && ((0, jsx_runtime_1.jsx)(antd_1.Row, { gutter: [16, 16], justify: "center", children: fieldsConfig.map(field => ((0, jsx_runtime_1.jsx)(renderBraintreeHostedField_1.BraintreeHostedField, { "data-cy": field[EFieldsAttributes.Id], id: field[EFieldsAttributes.Id], label: field[EFieldsAttributes.Label], className: field[EFieldsAttributes.ClassName] }, field[EFieldsAttributes.Id]))) })), (0, jsx_runtime_1.jsx)(antd_1.Row, { gutter: [16, 16], justify: "center", className: "m-t-l", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "primary", onClick: sendPayment, loading: isPaymentInProgress || isBraintreeLoading || isOrderLoading, icon: (0, jsx_runtime_1.jsx)(icons_1.LockOutlined, {}), children: intl.formatMessage({
                                            id: 'global.checkout.pay_with_card',
                                            defaultMessage: 'Zaplatiť kartou',
                                        }) }) }), (order === null || order === void 0 ? void 0 : order.orderType) !== types_1.ProductType.subscription && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (!useSavedCard || !hasRememberedCard) && ((0, jsx_runtime_1.jsx)("div", { className: "flex-center m-t-l", children: (0, jsx_runtime_1.jsx)(elements_1.Checkbox, { checked: shouldSaveCard, onChange: e => setShouldSaveCard(e.target.checked), children: intl.formatMessage({
                                                id: 'global.checkout.save_card',
                                            }) }) })) }))] })] }) }) }) }));
};
exports.Checkout = Checkout;
